export const MAINTENANCE_TASKS_COLLECTION = 'maintenanceTasks';
